import { BetSlipStatus } from "@api-types/agency/bet-slip/BetSlipStatus";
import { BetStatus as BetStatusType } from "@api-types/bet-slip/BetStatus";
import { BetStatusAbrv } from "@data-types/bet-slip/BetStatus";
import { BetSlipStatusAbrv } from "@utils/common";

export function shouldUseSlipStatusInstead(bet: {
	betSlipStatus: BetSlipStatus;
	betStatus: BetStatusType;
}) {
	return (
		bet.betStatus.abrv == BetStatusAbrv.RETURNED &&
		bet.betSlipStatus.abrv == BetSlipStatusAbrv.FOR_RETURNED
	);
}
